"use client";

import SiteNav from "@/components/SiteNav";
import Home from "@/components/pages/Home";

export default function HomePage() {
  return (
    <>
      <SiteNav />
      <Home />
    </>
  );
}
